import { bool, func, object } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateEditorSettings, useEstimateEditorStore } from "@tools";
import { formatPrice } from "@utils";
import { MenuButton } from "@components";
import Grid from "@material-ui/core/Grid";
import { AddCircleOutline } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles"

export const ListItem = observer(({
  role,
  disabled,
  onClick,
  americanPriceFormat,
  showSalesRates,
}) => {
  const editorStore = useEstimateEditorStore();
  const { hasSellerPrivileges, useProfitability } = useEstimateEditorSettings();
  const classes = useStyle();

  const { defaultCostCurrencyObj, defaultSalesCurrencyObj } = editorStore;

  return (
    <Grid item container alignItems="center">
      <MenuButton
        icon={<AddCircleOutline color={disabled ? "disabled" : "primary"} />}
        className={classes.item}
        onClick={onClick}
        disabled={disabled}
      >
        <Grid item container>
          <Grid item container xs={4} className="text-xs font-bold">
            {role.roleName}
          </Grid>
          <Grid item xs={3} className="text-xs text-secondary">
            {
              hasSellerPrivileges && useProfitability &&
              formatPrice(role.costRate, defaultCostCurrencyObj, americanPriceFormat ? 2 : -1)
            }
          </Grid>
          <Grid item xs={3} className="text-xs text-secondary">
            {
              hasSellerPrivileges && (useProfitability || showSalesRates) &&
              formatPrice(role.salesRate, defaultSalesCurrencyObj, americanPriceFormat ? 2 : -1)
            }
          </Grid>
        </Grid>
      </MenuButton>
    </Grid>
  );
});

ListItem.propTypes = {
  role: object.isRequired,
  onClick: func.isRequired,
  disabled: bool,
  americanPriceFormat: bool,
  showSalesRates: bool,
};

const useStyle = makeStyles(() => ({
  item: {
    width: "100%",
    height: "max-content",
    padding: "6px 8px 6px 16px",
    "& > span": {
      flexDirection: "row-reverse",
      justifyContent: "space-between",
    },
    "& svg": {
      fontSize: 24,
    },
    "& .MuiTouchRipple-ripple": {
      width: "100% !important",
      left: "0 !important",
    },
  },
}));
